export default "__VITE_ASSET__CVpsi0U5__"